import * as React from 'react';
var CascaderContext = /*#__PURE__*/React.createContext({
  changeOnSelect: false,
  expandTrigger: 'click',
  fieldNames: null,
  expandIcon: null,
  loadingIcon: null,
  loadData: null,
  dropdownMenuColumnStyle: null,
  search: null,
  requestFailureIcon: null,
  requestFailureText: '请求失败',
  refreshText: '刷新',
  empty: null,
  virtual: false,
  treeCheckStrictly: false
});
export default CascaderContext;